export const weekStarterArray: string[] = [
  'sunday',
  'monday',
  '',
  '',
  '',
  '',
  'saturday',
];
